export const provinces = [
  {
    provinceName: 'ardabil',
    provinceFaName: 'اردبیل',
  },
  {
    provinceName: 'isfahan',
    provinceFaName: 'اصفهان',
  },
  {
    provinceName: 'alborz',
    provinceFaName: 'البرز',
  },
  {
    provinceName: 'ilam',
    provinceFaName: 'ایلام',
  },
  {
    provinceName: 'eastAzerbaijan',
    provinceFaName: 'آذربایجان شرقی',
  },
  {
    provinceName: 'westAzerbaijan',
    provinceFaName: 'آذربایجان غربی',
  },
  {
    provinceName: 'bushehr',
    provinceFaName: 'بوشهر',
  },
  {
    provinceName: 'tehran',
    provinceFaName: 'تهران',
  },
  {
    provinceName: 'chaharmahalandBakhtiari',
    provinceFaName: 'چهارمحال و بختیاری',
  },
  {
    provinceName: 'southKhorasan',
    provinceFaName: 'خراسان جنوبی',
  },
  {
    provinceName: 'razaviKhorasan',
    provinceFaName: 'خراسان رضوی',
  },
  {
    provinceName: 'northKhorasan',
    provinceFaName: 'خراسان شمالی',
  },
  {
    provinceName: 'khuzestan',
    provinceFaName: 'خوزستان',
  },
  {
    provinceName: 'zanjan',
    provinceFaName: 'زنجان',
  },
  {
    provinceName: 'semnan',
    provinceFaName: 'سمنان',
  },
  {
    provinceName: 'sistanAndBaluchestan',
    provinceFaName: 'سیستان و بلوچستان',
  },
  {
    provinceName: 'fars',
    provinceFaName: 'فارس',
  },
  {
    provinceName: 'qazvin',
    provinceFaName: 'قزوین',
  },
  {
    provinceName: 'qom',
    provinceFaName: 'قم',
  },
  {
    provinceName: 'kurdistan',
    provinceFaName: 'کردستان',
  },
  {
    provinceName: 'kerman',
    provinceFaName: 'کرمان',
  },
  {
    provinceName: 'kohgiluyehAndBoyerAhmad',
    provinceFaName: 'کهگیلویه و بویراحمد',
  },
  {
    provinceName: 'kermanshah',
    provinceFaName: 'کرمانشاه',
  },
  {
    provinceName: 'golestan',
    provinceFaName: 'گلستان',
  },
  {
    provinceName: 'gilan',
    provinceFaName: 'گیلان',
  },
  {
    provinceName: 'lorestan',
    provinceFaName: 'لرستان',
  },
  {
    provinceName: 'mazandaran',
    provinceFaName: 'مازندران',
  },
  {
    provinceName: 'markazi',
    provinceFaName: 'مرکزی',
  },
  {
    provinceName: 'hormozgan',
    provinceFaName: 'هرمزگان',
  },
  {
    provinceName: 'hamadan',
    provinceFaName: 'همدان',
  },
  {
    provinceName: 'yazd',
    provinceFaName: 'یزد',
  },
];
